import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneCall = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "phone_Call",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group",
		transform: "translate(2 2)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path",
				d: "M7.132,9.42A12.634,12.634,0,0,1,4.494,5.611a.749.749,0,0,1,.166-.827l.819-.819a1.53,1.53,0,0,0,.085-2.206L4.39.586a2,2,0,0,0-2.828,0L.91,1.237a3.194,3.194,0,0,0-.85,2.87A15.715,15.715,0,0,0,4.521,12.03a15.715,15.715,0,0,0,7.923,4.461,3.194,3.194,0,0,0,2.87-.85l.651-.651a2,2,0,0,0,0-2.828l-1.173-1.173a1.5,1.5,0,0,0-2.121,0l-.9.9a.749.749,0,0,1-.827.166A12.674,12.674,0,0,1,7.132,9.42Z",
				transform: "translate(0.916 2.449)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeMiterlimit: 10,
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path-2",
				"data-name": "Path",
				d: "M.5,2.34V0",
				transform: "translate(10.42 0.83)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeMiterlimit: 10,
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path-3",
				"data-name": "Path",
				d: "M0,1.64,1.65,0",
				transform: "translate(15.09 3.18)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeMiterlimit: 10,
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path-4",
				"data-name": "Path",
				d: "M0,.5H2.33",
				transform: "translate(16.75 8.5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeMiterlimit: 10,
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path-5",
		"data-name": "Path",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgPhoneCall;
